module.exports = "/images/tc.svg?dac2d71cfdd1ad76d5ca126b763a1789";